import React, {useRef, useEffect, useState} from "react";
import Header from "../../components/Header";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";

import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../../components/Footer";
import LoginComponent from "../../components/Profile/LoginComponent";

function Login() {
    return (
        <div >
            <Header/>
            <div className="container" style={{paddingTop: 86, minHeight: "100vh"}}>
                <LoginComponent/>
            </div>
            <Footer/>
        </div>
    );
}

export default Login;